<template>
  <Slider v-if="data.length !== 0">
    <div v-for="product in data" :key="product._id">
      <product-card :product="product" />
    </div>
  </Slider>
</template>

<script>
import axios from 'axios';
import Slider from './Utilities/Share/Slider';
import ProductCard from './Utilities/Cards/Product';

export default {
  props: {
    type: {
      default: 1,
    },
    data: {
      type: Array,
    },
  },
  components: {
    Slider,
    ProductCard,
  },
  data() {
    return {
      products: [],
    };
  },
  computed: {
    activeOnce() {
      return this.products.filter((product) => product.isActive);
    },
  },
  created() {},
  methods: {
    navigate(slug) {
      this.$router.push({ path: `/product/${slug}` });
    },
  },
};
</script>
